import gCard from "@/components/g-card/g-card.vue";
import router from "@/router";

const name = 'g-tab-view'

export default { 
    name,

    emits: ['tabChange'],

    components:{ 
        "g-card": gCard,
    },

    watch: {
        '$route': function() {
            this.verificaRoute()
        }
    },

    props: { 
        items: {
            type: Array,
            default: []
          },
          tabChange: {
            type: Function,
            default: () => {}
          },
          itemAtivo: {
            type: Number,
            default: 0
          }
    },

    mounted() { 
        this.verificaRoute()

    },

    updated() { },

    data() {
        return { 
            teste: null
        }
    },

    methods: { 
        verificaRoute () {
            let route =  this.items.findIndex((Element) => Element.to === window.location.pathname )
            this.$emit('RouterIndex', route)
        },

        caminho(link) {
            router.push(link)
        },
    },

    computed: {
        itemsAtivos(){
            return this.items.filter(e => e.flag)
        }
    }
}
